export default __webpack_public_path__ + "static/si-logo-lg-6c141f567ff04711657b032caa9992b5.jpg";